var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.875 43.7498H3.125C1.97461 43.7498 1.04199 42.8162 1.04199 41.6668C1.04199 40.5173 1.97559 39.5837 3.125 39.5837H46.875C48.0254 39.5837 48.958 40.5173 48.958 41.6668C48.958 42.8162 48.0254 43.7498 46.875 43.7498Z",
    fill: "#0E3368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875 20.833H3.125C1.97461 20.833 1.04199 19.8994 1.04199 18.75C1.04199 17.6006 1.97559 16.667 3.125 16.667H46.875C48.0254 16.667 48.958 17.6006 48.958 18.75C48.958 19.8994 48.0254 20.833 46.875 20.833Z",
    fill: "#0E3368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 50C0.933594 50 0 49.0664 0 47.917V2.08301C0 0.933594 0.933594 0 2.08301 0C3.23242 0 4.16602 0.933594 4.16602 2.08301V47.916C4.16699 49.0664 3.2334 50 2.08301 50Z",
    fill: "#0E3368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.917 50C46.7666 50 45.834 49.0664 45.834 47.917V2.08301C45.833 0.933594 46.7666 0 47.917 0C49.0674 0 50 0.933594 50 2.08301V47.916C50 49.0664 49.0664 50 47.917 50Z",
    fill: "#0E3368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1455 27.083V28.6455C16.1455 29.5078 15.4453 30.208 14.583 30.208C13.7207 30.208 13.0205 29.5078 13.0205 28.6455V27.083H9.375C8.7998 27.083 8.33301 27.5498 8.33301 28.125V36.458C8.33301 37.0332 8.7998 37.5 9.375 37.5H19.792C20.3672 37.5 20.834 37.0332 20.834 36.458V28.125C20.834 27.5498 20.3672 27.083 19.792 27.083H16.1455Z",
    fill: "#4CCD8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8545 25V26.5625C33.8545 27.4248 33.1543 28.125 32.292 28.125C31.4297 28.125 30.7295 27.4248 30.7295 26.5625V25H26.042C25.4668 25 25 25.4668 25 26.042V36.459C25 37.0342 25.4668 37.501 26.042 37.501H38.542C39.1172 37.501 39.584 37.0342 39.584 36.459V26.042C39.584 25.4668 39.1172 25 38.542 25H33.8545Z",
    fill: "#4CCD8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 4.16724V5.72974C20.3125 6.59204 19.6123 7.29224 18.75 7.29224C17.8877 7.29224 17.1875 6.59204 17.1875 5.72974V4.16724H11.458C10.8828 4.16724 10.416 4.63403 10.416 5.20923V13.5422C10.416 14.1174 10.8828 14.5842 11.458 14.5842H26.041C26.6162 14.5842 27.083 14.1174 27.083 13.5422V5.20825C27.083 4.63306 26.6162 4.16626 26.041 4.16626H20.3125V4.16724Z",
    fill: "#4CCD8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.4c80f013.svg";
export { ForwardRef as ReactComponent };